import { UTMObject } from "../api/events";

// Why truncate the URL? It's better than crashing due to an HTTP 413 Content
// Too Large or HTTP 502 Bad Gateway error.
//
// Why this number? There's no standard for maximum URL length, so I just tested
// various values to see what would crash our system. Then I went notably lower
// to be extra careful in case we add a system with a shorter restriction in the
// future.
//
// https://zapierorg.atlassian.net/browse/TPS-2344
const urlMaxLength = 1024;

// We bloat the URL with a lot of info, so we need to take care not to make the
// URL so long that it is denied by HTTP servers
export function urlWithReferrer(url: string, referrer: string): string {
  const refURL = new URL(url);
  // Why both spellings? The monolith checks both spellings in various
  // locations, so let's just use both! :sob:
  refURL.searchParams.set("referer", referrer);
  refURL.searchParams.set("referrer", referrer);
  if (refURL.href.length > urlMaxLength) {
    // I think we're less likely to use `referrer` throughout our backend, so
    // let's delete that if we're tight on space.
    refURL.searchParams.delete("referrer");
  }
  return refURL.href.slice(0, urlMaxLength);
}

export function referrerWithUTMs(
  referrer: string,
  utmObject: UTMObject,
): string {
  // NOTE: It might be a good idea to strip the URL params from the referring
  // page here in order to save space and increase privacy, but we should get
  // approval from someone on the data team before doing that
  const innerReferrer = new URL(referrer);
  const url = new URL(referrer);
  for (const [key, val] of Object.entries(utmObject)) {
    url.searchParams.set(key, val);
  }
  // Why are setting referer inside the referer? Some systems at Zapier are
  // dropping the top level `referer` param, so this gives us a second chance to
  // find it.
  //
  // https://zapier.slack.com/archives/CH0SN5V0V/p1681422367948069?thread_ts=1681420248.783549&cid=CH0SN5V0V
  url.searchParams.set("referer", innerReferrer.href);
  return url.href;
}
